<template>
  <div class="h-100">
    <router-view />
    <!-- <color-switcher /> -->
  </div>
</template>
<script>
  // import ColorSwitcher from '@/components/Common/ColorSwitcher'

  import '../node_modules/font-awesome/scss/font-awesome.scss'
  import '../src/components/custom/jquery-confirm-master/css/jquery-confirm.css'
  import { msg } from '../src/components/custom/alert-service.js'

  window.$msg = msg

  export default {
    components: {
      // ColorSwitcher
    }
  }
</script>

<style>
</style>
